export const clearToken = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("token");
    window.location.pathname = "/"; 
}